module["exports"] = ["South Africa", "The Republic of South Africa", "SA", "South Africa"];